export const isOverflown = (element) => {
  return element
    ? element.clientWidth < element.scrollWidth || element.clientHeight < element.scrollHeight
    : false;
};
